import { Button, Col, Divider, Loader, Row } from "@/components";
import clsx from "clsx";
import { ComponentType } from "react";
import { Download } from "../../../icons";
import "./CardPaymentDocument.scss";

type CardPaymentDocumentProps = {
  headerText?: string;
  beforeTitle?: {
    leftText?: string;
    rightBadgeText?: string;
    rightBadgeColor?: string;
  }
  title?: string;
  subtitle?: string | React.ReactNode;
  footer?: {
    descriptionText?: string | React.ReactNode;
    downloadDoc?: {
      label?: string;
      clickCta?: () => void;
    },
    ctaRight?: {
      label?: string;
      href?: string;
    }
  };
  isLoading?: boolean;
  asLink?: "a" | ComponentType<any>;
};

export const CardPaymentDocument = ({
  headerText,
  beforeTitle,
  title,
  subtitle,
  footer,
  isLoading,
  asLink= "a",
}: CardPaymentDocumentProps) => {
  const LinkComponent = asLink;

  return (
    <div
      className={clsx(
        "ui-card-payment shadow br-x4 fw-semibold text-slate-28 fs-7",
      )}
    >
      <Row
        max-h={"x40"}
        min-h={"x40"}
        as={"header"}
        justifyContent={"flex-end"}
        alignItems={"center"}
        px={"x24"}
        className={"ui-card-payment-header"}
      >
        <Row className={"fw-semibold fs-7"}>
          {headerText}
        </Row>
      </Row>
      <div className={"ui-card-payment-main py-x16 px-x24"}>
        <Col
          pb={"x32"}
          justifyContent={"space-between"}
          gap={"x8"}
        >
          <Row justifyContent={beforeTitle?.rightBadgeText ? "space-between" : "flex-end"} alignItems={"center"}>
            {beforeTitle && (
              <div className={"fw-semibold"}>
                {beforeTitle?.leftText}
              </div>
            )}
            {beforeTitle?.rightBadgeText && (
              <div
                className={clsx(
                  "rounded py-x4 px-x16",
                )}
                style={{ backgroundColor: beforeTitle.rightBadgeColor || "#000", color: "#fff", width: "max-content" }}
              >
                {beforeTitle.rightBadgeText}
              </div>
            )}
          </Row>
          <h3
            className={clsx(
              "ui-card-payment-title fs-4 text-slate-20",
              "cursor-pointer hover-underline",
            )}
          >
            <LinkComponent className="link-unstyled" href={footer?.ctaRight?.href ?? "#"}>
              {title}
            </LinkComponent>
          </h3>
          {subtitle && <div style={{fontWeight: 500}}>{subtitle}</div>}
        </Col>

        {/* FOOTER */}
        {footer && (
          <Col mt={"x16"} className="ui-card-payment-footer">
            {footer?.descriptionText && (
              <div>
                {footer?.descriptionText && (
                  <p className={"fw-regular fs-7 text-slate-28 mb-x8"}>
                    {footer.descriptionText}
                  </p>
                )}
              </div>
            )}
            <Row className="ui-card-payment-footer-actions" justifyContent={footer?.downloadDoc ? "space-between" : "flex-end"} alignItems={"center"}>
              {footer?.downloadDoc && (
                <Row
                  alignItems={"center"}
                  className={clsx(
                    !isLoading && "cursor-pointer",
                    "text-decoration-none text-primary",
                    "ui-card-payment-download-row",
                  )}
                  onClick={isLoading ? undefined : footer?.downloadDoc?.clickCta}
                >
                  <Download />
                  <p>{footer?.downloadDoc?.label}</p>
                  <Loader loading={isLoading} className={"ml-x8"} />
                </Row>
              )}
              {footer?.ctaRight && footer?.ctaRight?.href && (
                <>
                  <Divider bg={"border-divider"} className="ui-document-divider" />
                  <Button
                    fwClassName="fw-semibold"
                    className="ui-card-payment-cta px-x12"
                    variant="secondary"
                    size="5"
                    asLink={LinkComponent}
                    href={footer?.ctaRight?.href ?? undefined}
                  >
                    {footer?.ctaRight?.label}
                  </Button>
                </>
              )}
            </Row>
          </Col>
        )}
      </div>
    </div>
  );
};
